import { EJsonQueryPriceType } from '@cian/api-models/common/json_query';

import { CoworkingSwitchButtonModel } from '../models/CoworkingSwitchButtonModel';
import { CoworkingSwitchButtonsCollectionModel } from '../models/CoworkingSwitchButtonsCollectionModel';

export const coworkingSwitchButtonsMapper = new CoworkingSwitchButtonsCollectionModel(
  new CoworkingSwitchButtonModel('За всё', 'all'),
  new CoworkingSwitchButtonModel('За рабочее место', EJsonQueryPriceType.Workplace),
).collection;
